var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-4" }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center mb-1" },
      [
        _c("label", { staticClass: "small font-weight-bold text-muted mb-0" }, [
          _vm._v("Vista previa de la estampa")
        ]),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("label", { staticClass: "small text-muted mb-0 mr-1" }, [
              _vm._v("Zoom")
            ]),
            _c("b-form-select", {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticStyle: { width: "auto" },
              attrs: {
                size: "sm",
                options: _vm.zoomOptions,
                title: _vm.zoomTooltip
              },
              model: {
                value: _vm.previewZoom,
                callback: function($$v) {
                  _vm.previewZoom = _vm._n($$v)
                },
                expression: "previewZoom"
              }
            }),
            _c("feather-icon", {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "ml-1 text-muted",
              attrs: { icon: "InfoIcon", size: "14", title: _vm.zoomTooltip }
            }),
            _c(
              "span",
              {
                staticClass: "badge badge-light border text-muted ml-2",
                attrs: { title: "Ancho x alto que se está usando" }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.effectiveAncho) +
                    " × " +
                    _vm._s(_vm.effectiveAlto) +
                    " "
                )
              ]
            )
          ],
          1
        )
      ]
    ),
    _c(
      "div",
      { staticClass: "contenedor-preview-estampa", style: _vm.previewBoxStyle },
      [
        _vm.previewUrl && !_vm.isLoading
          ? _c("img", { attrs: { src: _vm.previewUrl, alt: "Preview" } })
          : _vm.isLoading
          ? _c("div", [_vm._v("Cargando...")])
          : _c("div", [_vm._v("No hay estampa disponible")])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }